<div class="db-recharge-header-banner" *ngIf="userSubscription && userSubscription.recharge">
  <div class="db-recharge-header-banner__content">
    <div class="db-recharge-header-banner__content-text">
      <i class="db-icon db-icon-ds-exclamation-bg"></i>
      <b>{{'text_rechargePaymentFailedTitle' | dbText}}.</b> {{(userSubscription?.plan?.type === UserSubscriptionType.ONE_PRODUCT ? 'text_rechargePaymentFailedUnavailable2' : 'text_rechargePaymentFailedUnavailable1') | dbText}}</div>
    <div class="db-recharge-header-banner__content-button ml20">
      <a class="ds-btn ds-btn-s ds-btn-white-gray-border" (click)="renewUserSubscription(true)"><span>Retry Now</span></a>
    </div>
  </div>
</div>
